import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetDonorSummaryReport } from '../../../actions/reports/donor-summary';
import { fetchDonorSummaryReport } from '../../../sagas/reports/donor-summary/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchDonorSummaryReportHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetDonorSummaryReportHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchDonorSummaryReportHandler(fetchDonorSummaryReport),
  ...resetDonorSummaryReportHandler(resetDonorSummaryReport)
});
